import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadCountries } from 'redux/reducers/countries';

import {
  StyledList,
  StyledListItem,
  StyledCompareBullet,
  DisplayName,
  CompareItem,
  CompareItemBody,
  CopmareItemsWrapper,
} from '../CompareLegend.style';
import {
  VerticalLine,
  GorizontalLine,
} from 'components/TopicFilters/TopicFilters.styles';

interface ICountryCompareLegendProps {
  countryIds: string[];
  /** Should we show a stacked legend for smaller screens */
  isSmallScreen: boolean;
  /** Is the Legend expanded or collapsed */
  isExpanded?: boolean;
  isLessThan1024px?: boolean;
}

/** Displays a list of countries that are being compared */
const CountryCompareLegend: React.FC<ICountryCompareLegendProps> = (props) => {
  const { countryIds, isSmallScreen, isExpanded, isLessThan1024px } = props;

  const showMediumSize = isLessThan1024px && countryIds?.length > 2;

  // Load the country metadata on mount.
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCountries());
  }, [dispatch]);

  const countries = useSelector((state: any) => state.countries.data);

  return (
    <CopmareItemsWrapper>
      <StyledList
        isStacked={isExpanded && isSmallScreen}
        column={isSmallScreen}
      >
        {countryIds.map((countryId, index) => {
          const country = countries.find(
            (country: any) => country.id === countryId
          );

          return (
            <StyledListItem
              key={countryId}
              isStacked={isExpanded && isSmallScreen}
            >
              <CompareItem alignItems="center">
                <StyledCompareBullet index={index} marginTop="0" />
                <CompareItemBody>
                  <DisplayName
                    isExpanded={isExpanded}
                    showMediumSize={showMediumSize}
                    isSmallScreen={isSmallScreen}
                  >
                    <div>
                      {`${country ? country.displayName : null} (${countryId})`}
                    </div>
                  </DisplayName>
                </CompareItemBody>
              </CompareItem>
              {!isSmallScreen && (
                <VerticalLine
                  margin={`0 ${
                    index !== countryIds.length - 1
                      ? '0'
                      : showMediumSize
                      ? '15px'
                      : '30px'
                  } 0 ${showMediumSize ? '10px' : '20px'}`}
                />
              )}
            </StyledListItem>
          );
        })}
      </StyledList>
      {isSmallScreen && <GorizontalLine />}
    </CopmareItemsWrapper>
  );
};

export default CountryCompareLegend;
